import type { StoreWithActions } from './types';

import defaultStore from './defaultStore';

import { create } from 'zustand';

const useStore = create<StoreWithActions>((set) => ({
  store: defaultStore,
  loaders: defaultStore.loaders,
  setStore: (key, value) => {
    set((previous) => {
      const evaluated = typeof value === 'function' ? value(previous.store[key]) : value;
      const slice = {
        ...previous.store[key],
        ...evaluated,
      };
      const store = {
        ...previous.store,
        [key]: slice,
      };
      return {
        store,
        ...(key === 'loaders' ? { loaders: store.loaders } : {}),
      };
    });
  },
  setLoader: (key, value) => {
    set((previous) => {
      const loaders = {
        ...previous.store.loaders,
        [key]: typeof value === 'boolean' ? value : !previous.store.loaders[key],
      };
      return {
        loaders,
        store: {
          ...previous.store,
          loaders,
        },
      };
    });
  },
}));

export default useStore;
